const FETCH = 'FETCH';
const SAVE = 'SAVE';
const DELETE = 'DELETE';

const SHOW = 'SHOW';
const HIDE = 'HIDE';

const REQUEST = 'REQUEST';
const SUCCESS = 'SUCCESS';
const FAILURE = 'FAILURE';

/* CALL CENTER */
export const CALL_CENTER_VEHICLE_PROPERTIES = 'CALL_CENTER_VEHICLE_PROPERTIES';
export const FETCH_CALL_CENTER_VEHICLE_PROPERTIES = `${FETCH}.${CALL_CENTER_VEHICLE_PROPERTIES}.${REQUEST}`;
export const FETCH_CALL_CENTER_VEHICLE_PROPERTIES_SUCCESS = `${FETCH}.${CALL_CENTER_VEHICLE_PROPERTIES}.${SUCCESS}`;
export const FETCH_CALL_CENTER_VEHICLE_PROPERTIES_FAILURE = `${FETCH}.${CALL_CENTER_VEHICLE_PROPERTIES}.${FAILURE}`;

export const CUSTOMER_INFORMATION = 'CUSTOMER_INFORMATION';
export const FETCH_CUSTOMER_INFORMATION = `${FETCH}.${CUSTOMER_INFORMATION}.${REQUEST}`;
export const FETCH_CUSTOMER_INFORMATION_SUCCESS = `${FETCH}.${CUSTOMER_INFORMATION}.${SUCCESS}`;
export const FETCH_CUSTOMER_INFORMATION_FAILURE = `${FETCH}.${CUSTOMER_INFORMATION}.${FAILURE}`;

export const CALL_CENTER_IVS_VIN = 'CALL_CENTER_IVS_VIN';
export const FETCH_CALL_CENTER_IVS_VIN = `${FETCH}.${CALL_CENTER_IVS_VIN}.${REQUEST}`;
export const FETCH_CALL_CENTER_IVS_VIN_SUCCESS = `${FETCH}.${CALL_CENTER_IVS_VIN}.${SUCCESS}`;
export const FETCH_CALL_CENTER_IVS_VIN_FAILURE = `${FETCH}.${CALL_CENTER_IVS_VIN}.${FAILURE}`;

export const SERVICE_REPAIR = 'SERVICE_REPAIR';
export const FETCH_SERVICE_REPAIR = `${FETCH}.${SERVICE_REPAIR}.${REQUEST}`;
export const FETCH_SERVICE_REPAIR_SUCCESS = `${FETCH}.${SERVICE_REPAIR}.${SUCCESS}`;
export const FETCH_SERVICE_REPAIR_FAILURE = `${FETCH}.${SERVICE_REPAIR}.${FAILURE}`;

export const SHOW_APPOINTMENT_CREATION_MODAL = `${SHOW}_APPOINTMENT_CREATION_MODAL`;
export const HIDE_APPOINTMENT_CREATION_MODAL = `${HIDE}_APPOINTMENT_CREATION_MODAL`;

export const SHOW_MESSAGE_APPOINTMENT_CREATION_MODAL = `${SHOW}_MESSAGE_APPOINTMENT_CREATION_MODAL`;
export const HIDE_MESSAGE_APPOINTMENT_CREATION_MODAL = `${HIDE}_MESSAGE_APPOINTMENT_CREATION_MODAL`;

export const LEASING_COMPANIES = 'LEASING_COMPANIES';
export const FETCH_LEASING_COMPANIES = `${FETCH}.${LEASING_COMPANIES}.${REQUEST}`;
export const FETCH_LEASING_COMPANIES_SUCCESS = `${FETCH}.${LEASING_COMPANIES}.${SUCCESS}`;
export const FETCH_LEASING_COMPANIES_FAILURE = `${FETCH}.${LEASING_COMPANIES}.${FAILURE}`;

export const PRE_JOURNEY_INFORMATION = 'PRE_JOURNEY_INFORMATION';
export const FETCH_PRE_JOURNEY_INFORMATION = `${FETCH}.${PRE_JOURNEY_INFORMATION}.${REQUEST}`;
export const FETCH_PRE_JOURNEY_INFORMATION_SUCCESS = `${FETCH}.${PRE_JOURNEY_INFORMATION}.${SUCCESS}`;
export const FETCH_PRE_JOURNEY_INFORMATION_FAILURE = `${FETCH}.${PRE_JOURNEY_INFORMATION}.${FAILURE}`;

export const CUSTOMER_DEALER_TIRE_BRAND = 'CUSTOMER_DEALER_TIRE_BRAND';
export const FETCH_CUSTOMER_DEALER_TIRE_BRAND = `${FETCH}.${CUSTOMER_DEALER_TIRE_BRAND}.${REQUEST}`;
export const FETCH_CUSTOMER_DEALER_TIRE_BRAND_SUCCESS = `${FETCH}.${CUSTOMER_DEALER_TIRE_BRAND}.${SUCCESS}`;
export const FETCH_CUSTOMER_DEALER_TIRE_BRAND_FAILURE = `${FETCH}.${CUSTOMER_DEALER_TIRE_BRAND}.${FAILURE}`;

export const DEALERS = 'DEALERS';
export const FETCH_DEALERS = `${FETCH}.${DEALERS}.${REQUEST}`;
export const FETCH_DEALERS_SUCCESS = `${FETCH}.${DEALERS}.${SUCCESS}`;
export const FETCH_DEALERS_FAILURE = `${FETCH}.${DEALERS}.${FAILURE}`;

/* APPOINTMENT */
export const CALL_CENTER_APPOINTMENT = 'CALL_CENTER_APPOINTMENT';
export const CALL_CENTER_MESSAGE_APPOINTMENT = 'CALL_CENTER_MESSAGE_APPOINTMENT';
export const SAVE_CALL_CENTER_APPOINTMENT = `${SAVE}.${CALL_CENTER_APPOINTMENT}.${REQUEST}`;
export const SAVE_CALL_CENTER_MESSAGE_APPOINTMENT = `${SAVE}.${CALL_CENTER_MESSAGE_APPOINTMENT}.${REQUEST}`;
export const SAVE_CALL_CENTER_APPOINTMENT_SUCCESS = `${SAVE}.${CALL_CENTER_APPOINTMENT}.${SUCCESS}`;
export const SAVE_CALL_CENTER_MESSAGE_APPOINTMENT_SUCCESS = `${SAVE}.${CALL_CENTER_MESSAGE_APPOINTMENT}.${SUCCESS}`;
export const SAVE_CALL_CENTER_APPOINTMENT_FAILURE = `${SAVE}.${CALL_CENTER_APPOINTMENT}.${FAILURE}`;
export const SAVE_CALL_CENTER_MESSAGE_APPOINTMENT_FAILURE = `${SAVE}.${CALL_CENTER_MESSAGE_APPOINTMENT}.${FAILURE}`;

export const SAVE_CUSTOMER_INFORMATION = `${SAVE}.${CUSTOMER_INFORMATION}`;
export const SAVE_GENERAL_INFORMATION = `${SAVE}.GENERAL_INFORMATION`;
export const SAVE_COMMENT = `${SAVE}.COMMENT`;
export const SAVE_DATE_APPOINTMENT = `${SAVE}.DATE_APPOINTMENT`;
export const DELETE_MY_DEALER = `${DELETE}MY_DEALER`;

/* INTERVENTION */
export const FETCH_INTERVENTIONS = `${FETCH}_INTERVENTIONS.${REQUEST}`;
export const TOGGLE_ARCHIVED = 'TOGGLE_ARCHIVED';
export const SET_FILTERS = 'SET_FILTERS';
export const RESET_FILTERS = 'RESET_FILTERS';



// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js